/* eslint-disable */
import { FILTER_ACCOUNT_SELECTED } from '../Filters.types';

/**
 * Action to select the account in the filters
 * @param {string} account The account
 * @returns {ActionCreator<FromPayload<Array<string>, ActionMeta, FILTER_ACCOUNT_SELECTED>>} The created `Action`
 */
const filtersSelectAccount = (account) => ({ fromPayload }) => {
  return fromPayload(account, {}, FILTER_ACCOUNT_SELECTED);
};

export default filtersSelectAccount;
